import authFetch from "./authfetch";
import AuthToken from "./authtoken";
import Modules from "../modules/modules";
import BaseModel from "../modules/BaseModel";

const remoteLocation = (process.env.NODE_ENV == "development" ? "http://localhost:3001/" : "/api/");
const loginModel = "Users";

export default class WebLLCRESTApi {
  constructor(module, vueRouter) {
    this.module = module;
    this.vueRouter = vueRouter;
  }
  
  getData(id, filter, relationship, relationshipModule) {
    var that = this;
    
    var getParameters = (filter ?
                "?filter=" + encodeURIComponent(JSON.stringify(filter)) :
                "");
    
    var url = (relationship ?
                this.module.toLowerCase() + "/" + encodeURIComponent(id) + "/" + relationship + getParameters :
                this.module.toLowerCase() + "/" + encodeURIComponent(id) + getParameters);
    
    if(id) {
      return authFetch(remoteLocation + url)
        .then(response => {
          if(this.checkLoggedIn(response)) {
            return response.json();
          }
          else {
            return [];
          }
        })
        .then(function(jsonObject) {
          return WebLLCRESTApi.createModels(Modules[(relationshipModule ? relationshipModule : that.module)], that, jsonObject);
        });
    }
    else {
      return authFetch(remoteLocation + this.module.toLowerCase() + getParameters)
        .then(response => {
          if(this.checkLoggedIn(response)) {
            return response.json();
          }
          else {
            return [];
          }
        })
        .then(function(jsonObject) {
          return WebLLCRESTApi.createModels(Modules[(relationshipModule ? relationshipModule : that.module)], that, jsonObject);
        });
    }
  }
  
  countData(filter) {
    var getParameters = (filter ?
                "?where=" + encodeURIComponent(JSON.stringify(filter)) :
                "");
    
    var url = this.module.toLowerCase() + "/count" + getParameters;
    
    return authFetch(remoteLocation + url)
        .then(response => {
          if(this.checkLoggedIn(response)) {
            return response.json();
          }
          else {
            return { count: 0 };
          }
        })
        .then(res => res.count);
  }
  
  updateData(id, newModel, relationship, relationshipModule,  rId) {
    var that = this;
    
    var url = (relationship ?
                this.module.toLowerCase() + "/" + encodeURIComponent(id) + "/" + relationship + "/" + rId :
                this.module.toLowerCase() + "/" + encodeURIComponent(id));
    
    return authFetch(remoteLocation + url,
      {
        method: (relationship ? "PUT" : "PATCH"),
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify(WebLLCRESTApi.translateModels(Modules[(relationshipModule ? relationshipModule : that.module)], that, newModel))
      });
  }
  
  updateDataWithWhere(newModel, where) {
    var that = this;
    
    return authFetch(remoteLocation + this.module.toLowerCase() + "/update?where=" + encodeURIComponent(JSON.stringify(where)),
      {
        method: ("POST"),
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify(WebLLCRESTApi.translateModels(Modules[that.module], that, newModel))
      });
  }
  
  addData(id, newModel, relationship, relationshipModule) {
    var that = this;
    
    // alternate call-style addData(newJsonData);
    if(!newModel)
      newModel = id;
    
    const url = (relationship ?
                  this.module.toLowerCase() + "/" + id + "/" + relationship :
                  this.module.toLowerCase());
    
    if(newModel instanceof FormData) {
      return authFetch(remoteLocation + url,
      {
        method: "POST",
        body: newModel
      });
    }
    else {
      return authFetch(remoteLocation + url,
        {
          method: "POST",
          headers: new Headers({
              'Content-Type': 'application/json'
          }),
          body: JSON.stringify(WebLLCRESTApi.translateModels(Modules[(relationshipModule ? relationshipModule : that.module)], that, newModel))
        });
    }
  }
  
  async exists(id) {
    var url = this.module.toLowerCase() + "/" + encodeURIComponent(id);
    
    const response = await authFetch(remoteLocation + url,
      {
        method: "GET",
      });
    
    return response.status == 200;
  }
  
  deleteData(id, relationship, rId) {
    var url = (relationship ?
                this.module.toLowerCase() + "/" + encodeURIComponent(id) + "/" + relationship + "/" + rId :
                this.module.toLowerCase() + "/" + encodeURIComponent(id));
    
    return authFetch(remoteLocation + url,
      {
        method: "DELETE",
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: ""
      });
  }
  
  remoteMethod(method, args, argsAsPathParams) {
    if(Array.isArray(args)) {
      var getParameters = (function() {
          if(argsAsPathParams) {
            return "/" + args.map(function(arg) { return encodeURIComponent(arg.value); }).join("/");
          }
          else {
            return "?" + args.map(function(arg) {
              return encodeURIComponent(arg.name) + "=" + encodeURIComponent(arg.value);
            }).join("&");
          }
      })();
      
      return authFetch(remoteLocation + this.module.toLowerCase() + "/" + method + getParameters);
    }
    else {
      if(args) {
        var contentType = (function() {
          if(typeof args == "string") {
            return "application/json";
          }
          else {
            return "multipart/form-data";
          }
        })();
        
        // if the content type is multipart then we need not send our own header as the formdata will set the multipart boundary
        var headers = (contentType == "multipart/form-data" ?
                        undefined :
                        new Headers({
                                  'Content-Type': contentType
                              }));
        
        return authFetch(remoteLocation + this.module.toLowerCase() + "/" + method,
                            {
                              method: 'POST',
                              body: args,
                              headers: headers,
                              credentials: 'same-origin'
                            });
      }
      else {
        return authFetch(remoteLocation + this.module.toLowerCase() + "/" + method,
                            {
                              method: 'GET',
                              credentials: 'same-origin'
                            });
      }
    }
  }
  
  checkLoggedIn(res) {
    if(res.status > 0 && res.status != 401) {
      return true;
    }
    else {
      localStorage.removeItem('user');
      
      if(this.vueRouter) {
        this.vueRouter.push("/login");
      }
      
      return false;
    }
  }
  
  loggedInTest() {
    return authFetch(remoteLocation + loginModel.toLowerCase() + "/me")
      .then(function(res) {
        return res.status == 200;
      });
  }
  
  login(username, password) {
    return fetch(remoteLocation + loginModel.toLowerCase() + "/login", {
        method: "POST",
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
          username: username,
          password: password
        })
      })
      .then(function(res) {
        if(res.status == 200) {
          return res.json().then(function(json) {
            AuthToken.saveToken(username, json.role, json.expiredPass, json.token);
            return json.token;
          });
        }
        else if(res.status == 401 || res.status == 422) {
          return null;
        }
        else {
          throw new Error("Couldn't access site");
        }
      });
  }
  
  logOut() {
    return authFetch(remoteLocation + loginModel.toLowerCase() + "/logout", {
        method: "POST"
      });
  }
  
  updateLoginData(id, newModel) {
    var that = this;
    
    var url = loginModel + "/" + id;
    
    return authFetch(remoteLocation + url,
      {
        method: "PATCH",
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify(newModel)
      });
  }
  
  getRelationship(id, relationship, filter) {
    var that = this;
    var getParameters = (filter ?
                "?filter=" + encodeURIComponent(JSON.stringify(filter)) :
                "");
    
    return authFetch(remoteLocation + this.module.toLowerCase() + "/" + id + "/" + relationship.name + getParameters)
        .then(response => response.json())
        .then(function(jsonObjects) {
          if(relationship.module) {
            return WebLLCRESTApi.createModels(Modules[relationship.module], that, jsonObjects);
          }
          else {
            return jsonObjects;
          }
        });
  }
  
  translateField(fieldName) {
    var nameMapping = Modules[this.module].nameMapping();
    
    for(var index=0; index<nameMapping.length; index++) {
      var nameMap = nameMapping[index];
      
      if(nameMap.modelName == fieldName)
        return nameMap.apiName;
    }
    
    return null;
  }
  
  static createModels(moduleClass, restApi, json) {
    if(Array.isArray(json)) {
      return json.map(function(row) {
        return moduleClass.createModel(restApi, row);
      });
    }
    else {
      return moduleClass.createModel(restApi, json);
    }
  }
  
  static translateModels(moduleClass, restApi, model) {
    return BaseModel.translateModelToApi(moduleClass, restApi, model, moduleClass.nameMapping());
  }
  
  static getLoggedInModel() {
    return loginModel;
  }
}



// WEBPACK FOOTER //
// ./src/api/api.js